module.exports = __webpack_public_path__ + "static/img/model-bg32.ab69ec5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg32.jpg
// module id = R1Xf
// module chunks = 0